require('../../../modules/es.array.iterator');
require('../../../modules/es.object.to-string');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').values;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/array/virtual/values.js
// module id = 4379
// module chunks = 25